import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Component, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { OrdersService } from '@app/services/order/orders.service';
@Component({

    selector: 'slider',
    templateUrl: 'slider.component.html',
    styleUrls: ['slider.component.scss']
})
export class SliderComponent {
    options: SwiperOptions = {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        spaceBetween: 0,
        loop: true,
        autoplay: 4000,
        autoplayDisableOnInteraction: false,
        lazyLoading: true
    };

    images = [
        "assets/images/sliders/1.jpg",
        "assets/images/sliders/8.jpg",
        "assets/images/sliders/3.jpg"
    ]

    @ViewChild('description') description: ElementRef;

    enablePayement = false;
    subs:Subscription;
    constructor(
        public router: Router,
        private renderer: Renderer2,
        private orderService: OrdersService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }


    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.renderer.setStyle(this.description.nativeElement, 'top', window.innerHeight / 3 + 'px');
        }

        this.subs = this.orderService.enablePayement.subscribe(
            (enablePayement) => {
                this.enablePayement = enablePayement
            }
        );
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
